module.exports = __webpack_public_path__ + "static/media/syncicon.32a53d13.svg";